import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { BootstrapVue } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "@/assets/sass/main.scss";

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

window.createConnectionsApp = (data = {}) => {
    new Vue({
        router,
        store,
        render: (h) => h(App, { props: { data } }),
    }).$mount("#app");
};

if (process.env.node_env === "development") {
    const script = document.createElement("script");
    script.innerHTML = "createConnectionsApp(data)";
    document.body.appendChild(script);
}
